import { Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "../styles/common.scss";
import { CasesFcDomainsLinks } from "../../constants/constants";
import BellIcon from "../../assets/icons/BellIcon";
import { getCase } from "../../services/cases";
import {
  getKeyFromText,
  getUserIdFromLocalStorage,
  matchRoutesFromMenuStructure,
} from "../../utils/Utilities";
import { useTranslation } from "react-i18next";
const CasesSideBar = ({ id }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const [updates, setUpdates] = useState([]);
  let uID = getUserIdFromLocalStorage();
  const fetchData = async () => {
    const result = await getCase(uID, localStorage.getItem("caseId"));
    if (result?.success) {
      if (result?.payLoad?.others?.length > 0) {
        setUpdates(
          result?.payLoad?.others.map((item) => item.sectionName.toLowerCase())
        );
      }
    }
  };
  useEffect(() => {
    fetchData();
  }, [location.pathname]);

  const findElementFromAduitTrails = (updatedElement, navElement) => {
    return navElement?.aduitTrailKey?.some(
      (elem) => elem.toLowerCase() === updatedElement
    );
  };
  return (
    <>
      <Stack className="cases-fc-domain-side-bar">
        {CasesFcDomainsLinks.filter((ele1) =>
          matchRoutesFromMenuStructure("cases").some(
            (ele2) => ":id" + ele1.to === ele2.route
          )
        )?.map((item) => {
          return (
            <NavLink
              key={item.id}
              to={`${id}${item.to}`}
              className={`side-link${
                location.pathname.split("/").includes(item.route)
                  ? " active"
                  : ""
              }`}
            >
              <span>{t(getKeyFromText(item.name))}</span>
              <div
                className="bell-icon"
                style={{
                  backgroundColor:
                    updates.findIndex((ele) =>
                      findElementFromAduitTrails(ele, item)
                    ) !== -1
                      ? "white"
                      : "transparent",
                  display:
                    updates.findIndex((ele) =>
                      findElementFromAduitTrails(ele, item)
                    ) == -1 && "none",
                }}
              >
                {updates.findIndex((ele) =>
                  findElementFromAduitTrails(ele, item)
                ) !== -1 && <BellIcon fill="#FF996C" width="20px" />}
              </div>
            </NavLink>
          );
        })}
      </Stack>
    </>
  );
};

export default CasesSideBar;
